export default __webpack_public_path__ + "static/media/left_trees.2b0be006.svg";